import * as forms from '../utils/forms';
import formElements from './form-elements';

export default {
  mixins: [formElements],

  data() {
    const data = {
      formData: {},
      hasErrors: false,
    };

    return data;
  },

  created() {
    forms.prepareFormData(this.formDataDef, this.formData, this);
    if (this.formStorageName) {
      forms.unmarshal(
        forms.withdrawFormData(this.formStorageName),
        this.formData,
      );
    }
  },

  methods: {
    inputChanged(newVal, valName) {
      this.formData[valName].val = newVal;
    },
    populateForm(data) {
      forms.unmarshal(data, this.formData);
    },
    marshalFormValues() {
      return forms.marshal(this.formData);
    },
    resetFormErrors() {
      forms.hideAllErrors(this.formData);
    },
    showFormErrors(errors) {
      return forms.showErrors(this.formData, errors);
    },
  },

  watch: {
    formData: {
      handler() {
        if (this.formStorageName) {
          forms.persistFormData(
            this.formStorageName,
            forms.marshal(this.formData),
          );
        }
      },
      deep: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form.js